<template>
  <div class="flex gap-4">
    <md-button
      class="md-just-icon md-success md-simple table-action"
      @click.native="editTask"
    >
      <md-icon>edit</md-icon>
    </md-button>
    <md-button
      class="md-just-icon md-danger md-simple table-action"
      @click.native="triggerConfirmDelete"
      v-if="userInfo.id === item.owner_id_no_sql"
    >
      <md-icon>close</md-icon>
    </md-button>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["item"],
  inject: ["confirmDelete"],
  computed: {
    ...mapGetters("user", { userInfo: "info" })
  },
  methods: {
    triggerConfirmDelete() {
      this.confirmDelete(this.item);
    },
    editTask() {
      if (this.item.type === "main-task") {
        this.$router.push({ path: `/edit-main-task/${this.item.id}` });
      } else {
        this.$router.push({ path: `/edit-individual-task/${this.item.id}` });
      }
    }
  }
};
</script>
